var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"buy-sell-offer-view"},[(_vm.sellOffer && _vm.project)?_c('BuySellOfferForm',{staticClass:"buy-sell-offer-view__form",attrs:{"project":_vm.project,"sellOffer":_vm.sellOffer}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }